import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/landing/landing.component').then(m => m.LandingComponent),
  },
  {
    path: 'main',
    loadComponent: () =>
      import('./features/main/main.component').then(m => m.MainComponent),
  },
  {
    path: 'choose-module',
    loadComponent: () =>
      import('./features/upload-module/upload-module.component').then(m => m.UploadModuleComponent),
  },
  {
    path: 'data-profiling-module',
    loadComponent: () =>
      import('./features/data-profiling-module/data-profiling-module.component').then(m => m.DataProfilingModuleComponent),
  },
  {
    path: 'strategy-planning-module',
    loadComponent: () =>
      import('./features/strategy-planning-module/strategy-planning-module.component').then(m => m.StrategyPlanningModuleComponent),
  },
  {
    path: 'execution-module',
    loadComponent: () =>
      import('./features/execution-module/execution-module.component').then(m => m.ExecutionModuleComponent),
  },
  {
    path: 'validation-module',
    loadComponent: () =>
      import('./features/validation-module/validation-module.component').then(m => m.ValidationModuleComponent),
  },
  // {
  //   path: 'images',
  //   loadComponent: () =>
  //     import('./features/images/images.component').then(m => m.ImagesComponent),
  // },
  {
    path: 'review-all',
    data: { mode: 'all' },
    loadComponent: () =>
      import('./features/variable-review/variable-review.component').then(m => m.VariableReviewComponent),
  },
  {
    path: 'review/:index',
    data: { mode: 'single' },
    loadComponent: () =>
      import('./features/variable-review/variable-review.component').then(m => m.VariableReviewComponent),
  },
  {
    path: 'review-human-intervention',
    data: { mode: 'human' },
    loadComponent: () =>
      import('./features/variable-review/variable-review.component').then(m => m.VariableReviewComponent),
  },
  { path: '**', redirectTo: '' },
];
